import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

// Components
import { StateHandler } from '../_shared/StateHandler'
import { UserCardList, UserInfo } from '../_shared/UserCardList'

// Libs
import useLiveMallSearchQuery from '@/hooks/useLiveMallSearchQuery'

// Constants
import { MerchantSearchType } from '@/types/live-mall-search/types'
import { LIVE_MALL_SEARCH_CATEGORY_MAP } from '../../utils/constants'
import { CategorySharedProps } from '../../utils/types'

const formatMerchants = (merchants: MerchantSearchType[] | undefined): UserInfo[] => {
  if (!merchants) return []

  return merchants.map((merchant) => ({
    merchantId: merchant.merchantId,
    memberId: merchant.memberId,
    coverImageUrl: merchant.headshotUrl,
    merchantName: merchant.merchantName,
    location: merchant.countryCode,
    isFollowed: merchant.isLike,
  }))
}

const VendorsContent = ({ allQueryResult, ...props }: CategorySharedProps) => {
  const { keyword, category } = useRouter().query
  const isAllCategory = category === 'all'

  const [merchants, setMerchants] = useState<UserInfo[]>([])
  const isEmpty = merchants.length === 0
  const { data: vendorQueryResult, isFetching } = useLiveMallSearchQuery({
    keyword: String(keyword),
    type: LIVE_MALL_SEARCH_CATEGORY_MAP.VENDOR,
    enabled: !isAllCategory && !!keyword,
  })
  const queryResult = allQueryResult || vendorQueryResult

  useEffect(() => {
    if (queryResult) {
      setMerchants(formatMerchants(queryResult.merchantList))
    }
  }, [queryResult])

  return (
    <StateHandler isFetching={isFetching} isEmpty={isEmpty}>
      <UserCardList users={merchants} {...props} />
    </StateHandler>
  )
}

export default VendorsContent
